import { useState, useEffect } from 'react';
import {
    Card,
    CardContent,
    Button,
    Typography,
    Divider,
    Box,
} from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { StatusBox } from '../../common/StatusBox/StatusBox';
import { Link as RouterLink } from 'react-router-dom';
import './CampaignBox.css';
import CopyCampaignModal from '../modals/CopyCampaignModal';
import { Campaign } from '../../types/campaign';
export interface boxData {
    boxData: Array<any>;
    boxIndex: number;
    campaigns: Campaign[]
    refetchCampaigns: () => void;
}

export default function CampaignBox({ boxData, boxIndex, campaigns, refetchCampaigns }: boxData) {
    const [data, setData] = useState(boxData[boxIndex]);
    const [isCopyModalOpen, setCopyModalOpen] = useState<boolean>(false);

    const toggleCopyCampaignModal = () => setCopyModalOpen(prev => !prev);

    const alignData = (inputData: any) => {
        if (!inputData || !inputData.configurations) {
            inputData.configurations = [];
        }
        return inputData;
    };

    useEffect(() => {
        setData(alignData(boxData[boxIndex]));
    }, [boxData, boxIndex]);

    return (
        <>
            <CopyCampaignModal
                isOpen={isCopyModalOpen}
                close={toggleCopyCampaignModal}
                copiedCampaign={boxData[boxIndex]}
                campaigns={campaigns}
                refetchCampaigns={refetchCampaigns}
            />
            <StyledEngineProvider injectFirst>
                <Card className='campaignCard'>
                    <CardContent className='campaignCardContent'>
                        <Box className='campaignBoxHeader'>
                            <Typography variant='h6' className='campaignBoxTitle'>
                                {data.promotion_name ? data.promotion_name : 'Name not specified'}
                            </Typography>
                            <Box className='campaignBoxButtons'>
                                <Button
                                    data-testid={`manage-campaign-button-${boxIndex}`}
                                    variant='contained'
                                    className='campaignBoxButton'
                                    size='small'
                                    component={RouterLink}
                                    to={`/editCampaign/${data.promotion_id}`}
                                >
                                    Manage
                                </Button>
                                <Button
                                    variant='contained'
                                    className='campaignBoxButton'
                                    size='small'
                                    onClick={toggleCopyCampaignModal}
                                >
                                    Copy
                                </Button>
                            </Box>
                        </Box>
                        <Typography variant='body2' className='promotionIdLabelStyles'>
                            {'ID: ' + data.promotion_id}
                        </Typography>
                        <Typography variant='body2' className='digitalExperienceStyles'>
                            {data.digital_experience && data.digital_experience.length > 1
                                ? data.digital_experience.join(' | ')
                                : data.digital_experience}
                        </Typography>
                        <Typography variant='body2' className='startEndDateLabelStyles'>
                            {new Date(data.promotion_start_utc).toLocaleDateString('de-CH') +
                            ' - ' +
                            new Date(data.promotion_end_utc).toLocaleDateString('de-CH')}
                        </Typography>
                    </CardContent>
                    <Divider variant='middle' />
                    <div className='cardFooter'>
                        <StatusBox
                            styleName='campaignStatus'
                            archived={data.archived}
                            numOfConfigs={data.configurations ? data.configurations.length : 0}
                        />
                        <Box>
                            <Typography className='livePromotionsCountLabelStyles'>
                                {data.configurations && data.configurations.length === 1
                                    ? data.configurations.length + ' promotion'
                                    : data.configurations && data.configurations.length > 1
                                        ? +data.configurations.length + ' promotions'
                                        : '0 promotions'}
                            </Typography>
                        </Box>
                    </div>
                </Card>
            </StyledEngineProvider>
        </>
    );
}

export { CampaignBox };
